/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteAntecedentFromBehaviorBIPInfo$Params {
  Behavior_BIPInfo_AntecedentID?: number;
}

export function DeleteAntecedentFromBehaviorBIPInfo(http: HttpClient, rootUrl: string, params?: DeleteAntecedentFromBehaviorBIPInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, DeleteAntecedentFromBehaviorBIPInfo.PATH, 'post');
  if (params) {
    rb.query('Behavior_BIPInfo_AntecedentID', params.Behavior_BIPInfo_AntecedentID, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

DeleteAntecedentFromBehaviorBIPInfo.PATH = '/api/Staff/DeleteAntecedentFromBehaviorBIPInfo';
